// Copyright (c) 2016 Deere & Company

import PropTypes from 'prop-types';
import React from 'react';
import ValidationAndErrorMessages from './validation-and-error-messages';

const InputWithError = (props) => {

    const {
        addMultiple, addMultipleData, errorMessage, isValid, vsrMessage, ...rest
    } = props;

    return (
        <span>
            <div>
                <input
                    {...rest}
                />
                {addMultiple && <div className="add-icon" onClick={addMultipleData} />}
            </div>
            <ValidationAndErrorMessages
                errorMessage={errorMessage}
                isValid={isValid}
                vsrMessage={vsrMessage}
            />
        </span>
    );

};

InputWithError.displayName = 'InputWithError';
InputWithError.propTypes = {
    errorMessage: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired,
    vsrMessage: PropTypes.string,
    addMultipleData: PropTypes.func,
    addMultiple: PropTypes.bool,
};

export default InputWithError;
